module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.cdd4387b.svg";